import AddPatientForm from 'components/form/admin/patient/AddPatientForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'

export default class AddPatient extends Component {
    render() {
        return (
            <>
             <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Patient</h4>
                                <AddPatientForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
